import React from 'react';
import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { timeValueToDate2, inputNumberAutoComma } from '../../lib/commonFunc/commonFunc';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import Button from '../common/Button';

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  font-family: 'Noto Sans KR';
`;

const DateControllBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
  gap: 12px;
`;

const DateControllBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  svg {
    font-size: 28px;
    color: #666;
  }
`;

const SummaryBlock = styled.div`
  background: #fff;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  display: flex;
  justify-content: space-around;
  padding: 24px 20px;
  margin-bottom: 20px;
`;

const SummaryDataBlock = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const SummaryMainText = styled.p`
  color: #1976d2;
  font-size: 32px;
  font-weight: 700;
  margin: 0;
`;

const SummarySubText = styled.span`
  color: #666;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const RecordBlock = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  background: linear-gradient(white 30%, rgba(255,255,255,0)),
              linear-gradient(rgba(255,255,255,0), white 70%) 0 100%,
              radial-gradient(farthest-side at 50% 0, rgba(0,0,0,.15), rgba(0,0,0,0)),
              radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.15), rgba(0,0,0,0)) 0 100%;
  background-repeat: no-repeat;
  background-color: white;
  background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;
  background-attachment: local, local, scroll, scroll;
  scrollbar-width: thin;
  scrollbar-color: #1976d2 #f5f5f5;

  ::-webkit-scrollbar {
    width: 8px;
  }
  
  ::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 4px;
  }
  
  ::-webkit-scrollbar-thumb {
    background-color: #1976d2;
    border-radius: 4px;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background-color: #1565c0;
  }
`;

const FcRecordBlock = styled.div`
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 12px;
  border: 1px solid #e0e0e0;
  transition: box-shadow 0.2s ease;
  
  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
`;

const FcTitle = styled.h3`
  font-weight: 600;
  font-size: 16px;
  color: #333;
  margin: 0 0 16px 0;
`;

const HistoryBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 16px;
`;

const AerobicDataBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

const Record = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #e9ecef;
  
  &:last-child {
    border-bottom: none;
  }
`;

const AerobicUnit = styled.div`
  color: #888;
  font-weight: 500;
  font-size: 14px;
  min-width: 60px;
  margin-right: 12px;
`;

const AerobicValue = styled.span`
  color: #333;
  font-weight: 600;
  font-size: 15px;
`;

const SetBlock = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Set = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #e9ecef;
  
  &:last-child {
    border-bottom: none;
  }
`;

const SetLabel = styled.label`
  color: #888;
  font-weight: 500;
  font-size: 14px;
  min-width: 60px;
  margin-right: 12px;
`;

const SetValue = styled.div`
  color: #333;
  font-weight: 600;
  font-size: 15px;
`;


const MoreInfoBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const EmptyBlock = styled.div``;

const RecordData = ({ onOpenModal, record, selectedDate, onChangeDate, findRecordFreeweightType }) => {
  if (!record)
    return (
      <Wrapper>
        <EmptyBlock></EmptyBlock>
      </Wrapper>
    );

  return (
    <Wrapper>
      <DateControllBlock>
        <DateControllBtn
          onClick={() => onChangeDate('previous')}
          className={'previous'}
        >
          <MdKeyboardArrowLeft />
        </DateControllBtn>
        {timeValueToDate2(selectedDate)}
        <DateControllBtn
          onClick={() => onChangeDate('next')}
          className={'next'}
        >
          <MdKeyboardArrowRight />
        </DateControllBtn>
      </DateControllBlock>
      <SummaryBlock>
        <SummaryDataBlock>
          <SummaryMainText>
            {record.fcGroup.fcGroupDetail &&
              record.fcGroup.fcGroupDetail.length}
          </SummaryMainText>
          <SummarySubText>운동</SummarySubText>
        </SummaryDataBlock>
        <SummaryDataBlock>
          <SummaryMainText>
            {record.fcGroup.fcGroupDetail &&
              parseInt(
                record.fcGroup.fcGroupDetail.reduce((total, fc) => {
                  return total + fc.complete.time;
                }, 0) / 60,
              )}
          </SummaryMainText>
          <SummarySubText>분</SummarySubText>
        </SummaryDataBlock>
        <SummaryDataBlock>
          <SummaryMainText>
            {record.fcGroup.fcGroupDetail &&
            record.fcGroup.fcGroupDetail.reduce((total, fc) => {
              return total + fc.complete.calorie;
            }, 0) === 0
              ? 0
              : record.fcGroup.fcGroupDetail.reduce((total, fc) => {
                  return total + fc.complete.calorie;
                }, 0) / 10}
          </SummaryMainText>
          <SummarySubText>Kcal</SummarySubText>
        </SummaryDataBlock>
      </SummaryBlock>
      <RecordBlock>
        {record.fcGroup.fcGroupDetail &&
          record.fcGroup.fcGroupDetail.map((fc) => (
            <FcRecordBlock key={fc.fcindex}>
              <FcTitle>{fc.fcname}</FcTitle>
              {[1, 2].includes(fc.fctype) ? (
                <HistoryBlock>
                  <AerobicDataBlock>
                    <Record>
                      <AerobicUnit>거리</AerobicUnit>
                      <AerobicValue>{`${fc.complete.distance / 1000} Km`}</AerobicValue>
                    </Record>
                    <Record>
                      <AerobicUnit>시간</AerobicUnit>
                      <AerobicValue>{`${parseInt(fc.complete.time / 60)} 분`}</AerobicValue>
                    </Record>
                    <Record>
                      <AerobicUnit>칼로리</AerobicUnit>
                      <AerobicValue>{`${
                        fc.complete.calorie === 0 ? 0 : fc.complete.calorie / 10
                      } Kcal`}</AerobicValue>
                    </Record>
                  </AerobicDataBlock>
                  <MoreInfoBlock>
                    <Button cyan onClick={() => onOpenModal(fc)}>
                      자세히 보기
                    </Button>
                  </MoreInfoBlock>
                </HistoryBlock>
              ) : 
              ([3, 4].includes(fc.fctype) && findRecordFreeweightType(fc.fcindex) == 0) ? (
                <HistoryBlock>
                  <SetBlock>
                    {fc.complete.set.length > 0 &&
                      fc.complete.set.map((oneSet, i) => (
                        <Set key={i}>
                          <SetLabel>{`${i + 1}세트`}</SetLabel>
                          <SetValue>
                            {` ${oneSet.weight / 10}Kg  X  ${oneSet.count}회 `}
                          </SetValue>
                        </Set>
                      ))}
                  </SetBlock>
                  <MoreInfoBlock>
                    <Button cyan onClick={() => onOpenModal(fc)}>
                      자세히 보기
                    </Button>
                  </MoreInfoBlock>
                </HistoryBlock>
              ) :
              ([3, 4].includes(fc.fctype) && findRecordFreeweightType(fc.fcindex) == 1) ? (
                <HistoryBlock>
                  <SetBlock>
                    {fc.complete.set.length > 0 &&
                      fc.complete.set.map((oneSet, i) => (
                        <Set key={i}>
                          <SetLabel>{`${i + 1}세트`}</SetLabel>
                          <SetValue>
                            {`${oneSet.count}회 `}
                          </SetValue>
                        </Set>
                      ))}
                  </SetBlock>
                  <MoreInfoBlock>
                    <Button cyan onClick={() => onOpenModal(fc)}>
                      자세히 보기
                    </Button>
                  </MoreInfoBlock>
                </HistoryBlock>
              ) :
              ([3, 4].includes(fc.fctype) && findRecordFreeweightType(fc.fcindex) == 2) ? (
                <HistoryBlock>
                  <SetBlock>
                    {fc.complete.set.length > 0 &&
                      fc.complete.set.map((oneSet, i) => (
                        <Set key={i}>
                          <SetLabel>{`${i + 1}세트`}</SetLabel>
                          <SetValue>
                            {` ${oneSet.count}초 `}
                          </SetValue>
                        </Set>
                      ))}
                  </SetBlock>
                  <MoreInfoBlock>
                    <Button cyan onClick={() => onOpenModal(fc)}>
                      자세히 보기
                    </Button>
                  </MoreInfoBlock>
                </HistoryBlock>
              ) :
              ([5].includes(fc.fctype)) ? (
                <HistoryBlock>
                  <AerobicDataBlock>
                    <Record>
                      <AerobicUnit>거리</AerobicUnit>
                      <span>{`${
                        fc.complete.distance === 0 ? 0 : parseInt(fc.complete.distance / 100)/10
                      } km`}</span>
                    </Record>
                    <Record>
                      <AerobicUnit>고도</AerobicUnit>
                      <span>{`${
                        fc.complete.RM === 0 ? 0 : fc.complete.RM
                      } m`}</span>
                    </Record>
                    <Record>
                      <AerobicUnit>시간</AerobicUnit>
                      <span>{`${parseInt(fc.complete.time / 60)} 분`}</span>
                    </Record>
                    <Record>
                      <AerobicUnit>칼로리</AerobicUnit>
                      <span>{`${
                        fc.complete.calorie === 0 ? 0 : fc.complete.calorie / 10
                      } Kcal`}</span>
                    </Record>
                  </AerobicDataBlock>
                  <MoreInfoBlock>
                    <Button cyan onClick={() => onOpenModal(fc)}>
                      자세히 보기
                    </Button>
                  </MoreInfoBlock>
                </HistoryBlock>
              ) :
              ([6].includes(fc.fctype)) ? (
                <HistoryBlock>
                  <AerobicDataBlock>
                    <Record>
                      <AerobicUnit>운동 수</AerobicUnit>
                      <span>{`${fc.complete.set.length} 개`}</span>
                    </Record>
                    <Record>
                      <AerobicUnit>시간</AerobicUnit>
                      <span>{`${parseInt(fc.complete.time / 60)} 분`}</span>
                    </Record>
                    <Record>
                      <AerobicUnit>칼로리</AerobicUnit>
                      <span>{`${
                        fc.complete.calorie === 0 ? 0 : fc.complete.calorie / 10
                      } Kcal`}</span>
                    </Record>
                  </AerobicDataBlock>
                  <MoreInfoBlock>
                    <Button cyan onClick={() => onOpenModal(fc)}>
                      자세히 보기
                    </Button>
                  </MoreInfoBlock>
                </HistoryBlock>
              ) :
              null
              }
            </FcRecordBlock>
          ))}
      </RecordBlock>
    </Wrapper>
  );
};

export default RecordData;
